/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CarBasicDtoListGenericApiResponseFromJSON, CarDtoGenericApiResponseFromJSON, CarDtoListGenericApiResponseFromJSON, CarDtoListGenericServiceResultFromJSON, CarEditDtoGenericApiResponseFromJSON, CarEquipmentDtoGenericApiResponseFromJSON, CarHistoryReportDtoGenericApiResponseFromJSON, CarListDtoListGenericApiResponseFromJSON, CarMainDtoToJSON, CarNoteRequestToJSON, CarNoteSectionDtoGenericApiResponseFromJSON, CarPlateStatusDtoListGenericServiceResultFromJSON, CarRequestToJSON, CarServiceDtoToJSON, CarTechDtoToJSON, CarTireSectionDtoToJSON, CarTireSectionDtoGenericApiResponseFromJSON, ChangePhotoOrderRequestToJSON, FileDtoGenericApiResponseFromJSON, GenerateCarHistoryReportFileRequestToJSON, Int32GenericApiResponseFromJSON, OrderedFileDtoGenericApiResponseFromJSON, OrderedFileDtoListGenericApiResponseFromJSON, StringGenericApiResponseFromJSON, } from '../models';
/**
 *
 */
export class CarApi extends runtime.BaseAPI {
    /**
     */
    apiCarAddModelFileCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarAddModelFileCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request) {
                requestParameters.request.forEach((element) => {
                    formParams.append('request', element);
                });
            }
            const response = yield this.request({
                path: `/api/Car/addModelFile/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderedFileDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarAddModelFileCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarAddModelFileCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarAddcarexpandedPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/addcarexpanded`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CarRequestToJSON(requestParameters.carRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarAddcarexpandedPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarAddcarexpandedPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarAllGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/all`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarPlateStatusDtoListGenericServiceResultFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarAllGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarAllGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarAttachmentsCarIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarAttachmentsCarIdDelete.');
            }
            const queryParameters = {};
            if (requestParameters.fileId !== undefined) {
                queryParameters['fileId'] = requestParameters.fileId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/attachments/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarAttachmentsCarIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarAttachmentsCarIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiCarAttachmentsCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarAttachmentsCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request) {
                requestParameters.request.forEach((element) => {
                    formParams.append('request', element);
                });
            }
            const response = yield this.request({
                path: `/api/Car/attachments/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderedFileDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarAttachmentsCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarAttachmentsCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarCarIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarCarIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarCarIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarCarIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiCarChangephotoorderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/changephotoorder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ChangePhotoOrderRequestToJSON(requestParameters.changePhotoOrderRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarChangephotoorderPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarChangephotoorderPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarDeletemodelfileCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarDeletemodelfileCarIdPost.');
            }
            const queryParameters = {};
            if (requestParameters.fileId !== undefined) {
                queryParameters['fileId'] = requestParameters.fileId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/deletemodelfile/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarDeletemodelfileCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarDeletemodelfileCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarDeletephotofileCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarDeletephotofileCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/deletephotofile/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarDeletephotofileCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarDeletephotofileCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.plateNumber !== undefined) {
                queryParameters['PlateNumber'] = requestParameters.plateNumber;
            }
            if (requestParameters.modelId !== undefined) {
                queryParameters['ModelId'] = requestParameters.modelId;
            }
            if (requestParameters.makeId !== undefined) {
                queryParameters['MakeId'] = requestParameters.makeId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarHistoryCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarHistoryCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/History/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarHistoryReportDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarHistoryCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarHistoryCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarHistoryGeneratePdfPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/History/GeneratePdf`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GenerateCarHistoryReportFileRequestToJSON(requestParameters.generateCarHistoryReportFileRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarHistoryGeneratePdfPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarHistoryGeneratePdfPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiCarIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarRequestToJSON(requestParameters.carRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarIdPutRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiCarMainCarIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarMainCarIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/main/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarMainDtoToJSON(requestParameters.carMainDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarMainCarIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarMainCarIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarMakeMakeIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.makeId === null || requestParameters.makeId === undefined) {
                throw new runtime.RequiredError('makeId', 'Required parameter requestParameters.makeId was null or undefined when calling apiCarMakeMakeIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/make/{makeId}`.replace(`{${"makeId"}}`, encodeURIComponent(String(requestParameters.makeId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoListGenericServiceResultFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarMakeMakeIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarMakeMakeIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarModelModelIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
                throw new runtime.RequiredError('modelId', 'Required parameter requestParameters.modelId was null or undefined when calling apiCarModelModelIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/model/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoListGenericServiceResultFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarModelModelIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarModelModelIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarMultiGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.plateNumbers) {
                queryParameters['PlateNumbers'] = requestParameters.plateNumbers;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/multi`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarBasicDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarMultiGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarMultiGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarNotesCarIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarNotesCarIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/notes/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarNoteSectionDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarNotesCarIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarNotesCarIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarNotesCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarNotesCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/notes/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CarNoteRequestToJSON(requestParameters.carNoteRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarNotesCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarNotesCarIdPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiCarPhotosCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarPhotosCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request) {
                requestParameters.request.forEach((element) => {
                    formParams.append('request', element);
                });
            }
            const response = yield this.request({
                path: `/api/Car/photos/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderedFileDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarPhotosCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarPhotosCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarPhotosDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.carId !== undefined) {
                queryParameters['carId'] = requestParameters.carId;
            }
            if (requestParameters.fileId !== undefined) {
                queryParameters['fileId'] = requestParameters.fileId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/photos`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarPhotosDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarPhotosDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CarMainDtoToJSON(requestParameters.carMainDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarReplacecarmainphotoCarIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarReplacecarmainphotoCarIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request !== undefined) {
                formParams.append('request', requestParameters.request);
            }
            const response = yield this.request({
                path: `/api/Car/replacecarmainphoto/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderedFileDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarReplacecarmainphotoCarIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarReplacecarmainphotoCarIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarReplacecarmainphotobyidCarIdFileIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarReplacecarmainphotobyidCarIdFileIdPost.');
            }
            if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                throw new runtime.RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling apiCarReplacecarmainphotobyidCarIdFileIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/replacecarmainphotobyid/{carId}/{fileId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))).replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderedFileDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarReplacecarmainphotobyidCarIdFileIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarReplacecarmainphotobyidCarIdFileIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarSearchallGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.plateNumber !== undefined) {
                queryParameters['PlateNumber'] = requestParameters.plateNumber;
            }
            if (requestParameters.modelId !== undefined) {
                queryParameters['ModelId'] = requestParameters.modelId;
            }
            if (requestParameters.makeId !== undefined) {
                queryParameters['MakeId'] = requestParameters.makeId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/searchall`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarSearchallGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarSearchallGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarServiceCarIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarServiceCarIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/service/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarServiceDtoToJSON(requestParameters.carServiceDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarServiceCarIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarServiceCarIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarTechCarIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarTechCarIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/tech/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarTechDtoToJSON(requestParameters.carTechDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarTechCarIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarTechCarIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarTiresCarIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarTiresCarIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/tires/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarTireSectionDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCarTiresCarIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCarTiresCarIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCarTiresCarIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling apiCarTiresCarIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Car/tires/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarTireSectionDtoToJSON(requestParameters.carTireSectionDto),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarTiresCarIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarTiresCarIdPutRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiCarUpdatestatusPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.plateNumber !== undefined) {
                queryParameters['plateNumber'] = requestParameters.plateNumber;
            }
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/updatestatus`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiCarUpdatestatusPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCarUpdatestatusPutRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    getAllCarEquipmentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.carId === null || requestParameters.carId === undefined) {
                throw new runtime.RequiredError('carId', 'Required parameter requestParameters.carId was null or undefined when calling getAllCarEquipment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/getallcarequipment/{carId}`.replace(`{${"carId"}}`, encodeURIComponent(String(requestParameters.carId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEquipmentDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getAllCarEquipment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllCarEquipmentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getCarByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCarById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getCarById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCarByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getCarByPlateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.plate === null || requestParameters.plate === undefined) {
                throw new runtime.RequiredError('plate', 'Required parameter requestParameters.plate was null or undefined when calling getCarByPlate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/plate/{plate}`.replace(`{${"plate"}}`, encodeURIComponent(String(requestParameters.plate))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getCarByPlate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCarByPlateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getCarsAvailableForReservationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.carMakeId !== undefined) {
                queryParameters['carMakeId'] = requestParameters.carMakeId;
            }
            if (requestParameters.carModelId !== undefined) {
                queryParameters['carModelId'] = requestParameters.carModelId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.until !== undefined) {
                queryParameters['until'] = requestParameters.until.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/getcarsavailableforreservations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarListDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getCarsAvailableForReservations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCarsAvailableForReservationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getEditDtoByIdAsyncRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getEditDtoByIdAsync.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Car/editdto/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEditDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getEditDtoByIdAsync(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getEditDtoByIdAsyncRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
